import {
  Button,
  Classes,
  Dialog,
  HTMLTable,
  Tab,
  Tabs,
} from "@blueprintjs/core";
import { observable } from "mobx";
import { observer } from "mobx-react";
import * as moment from "moment";
import * as React from "react";
import { ResultadoStore } from "../../../../stores/resultados/ResultadoStore";
import { copyToClipboard } from "../../../../utils";
import { toast } from "react-toastify";
import { api } from "../../../../api";
import { AppStore } from "../../../../stores/AppStore";
import { ItemMemoria } from "./ItemMemoria";
const numeral = require("numeral");

interface CTEItemDialogProps {
  item: any;
  modelo: string;
  entrada_saida: string;
  onClose: () => void;
}

interface CTEItemDialogState { }

@observer
export class CTEItemDialog extends React.Component<
  CTEItemDialogProps,
  CTEItemDialogState
> {
  obs = observable({
    item: null as any,
    dhemi: null as string
  })
  async componentDidMount() {
    let data = {
      chave: this.props.item.chave,
      tipo: this.props.entrada_saida,
      item: this.props.item._id,
      modelo: this.props.modelo,
    };

    try {
      let resp = await api.post(`/api/notas/cte/item`, data);
      this.obs.dhemi = resp.data.dhemi;
      this.obs.item = resp.data;

      if(resp.data.calc_id) await ResultadoStore.loadDetalhamentoCalculo(resp.data.calc_id)

    } catch (ex) {
      toast.error("Erro ao visualizar Item CTE Contestação, tente novamente mais tarde.", {});
    }
  }

  renderNoData() {
    return (
      <div>
        Aguarde... &nbsp; &nbsp; &nbsp;

        <div className="spinner-border" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    );
  }

  handleViewXML = (chave: string, entrada_saida: string, modelo: string, dhemi: string) => {
    ResultadoStore.download_xml(chave, entrada_saida, modelo, dhemi, AppStore.obs1.selectedEmpresa?.cnpj);
  };

  handleCopyChave = () => {
    copyToClipboard(this.obs.item.chave);
    toast.success("Chave de acesso copiada", {});
  };

  handleCopyId = () => {
    copyToClipboard(this.obs.item?.contestacao_id);
    toast.success("Id Contestação copiado", {});
  };

  handleViewPDF = async () => {

    var ids = {
      ids: [this.obs.item.nota_id],
      filtro: this.props.entrada_saida,
      tipo: this.props.modelo,
      empresa: AppStore.obs1.selectedEmpresa.cnpj,
      data1: ResultadoStore.obs.date_start,
      data2: ResultadoStore.obs.date_end,
    };

    await ResultadoStore.view_danfe(ids, this.obs.item.chave);

  };

  renderDetailsTab() {
    return (
      <div>
        <HTMLTable
          className="table table-hover dataTable"
          style={{ width: "100%" }}
        >
          <tbody>
            <tr>
              <td style={{ verticalAlign: "middle" }}>Chave de acesso</td>
              <td style={{ verticalAlign: "middle" }}>
                <span style={{ marginRight: 10 }}>{this.obs.item.chave}</span>
                <Button
                  small
                  minimal
                  icon="clipboard"
                  onClick={this.handleCopyChave}
                />
              </td>
            </tr>

            <tr>
              <td>Serie / número</td>
              <td>
                {this.obs.item.serie}/{this.obs.item.numero}
              </td>
            </tr>
            <tr>
              <td>Data</td>
              <td>
                {moment(this.obs.item.data).format("DD/MM/YYYY")}{" "}
                {moment(this.obs.item.data).format("HH:mm")}
              </td>
            </tr>
            <tr>
              <td>Valor</td>
              <td style={{ textAlign: "right" }}>
                R$ {numeral(this.obs.item.valor).format("0,0.00")}
              </td>
            </tr>
            <tr>
              <td style={{ fontWeight: "bold" }}>CFOP</td>
              <td style={{ textAlign: "right", fontWeight: "bold" }}>
                {this.obs.item.cfop}
              </td>
            </tr>
            <tr>
              <td>CST</td>
              <td style={{ textAlign: "right" }}>{this.obs.item.cst}</td>
            </tr>
            <tr style={{ fontWeight: "bold" }}>
              <td>Cálculo</td>
              <td style={{ textAlign: "right" }}>{this.obs.item.calc}</td>
            </tr>
            <tr>
              <td style={{ verticalAlign: "middle" }}>ID Contestação</td>
              <td style={{ verticalAlign: "middle" }}>
                <span style={{ marginRight: 10 }}>{this.obs.item?.contestacao_id}</span>
                <Button
                  small
                  minimal
                  icon="clipboard"
                  onClick={this.handleCopyId}
                />
              </td>
            </tr>
          </tbody>
        </HTMLTable>
        <Button
          text="Download XML"
          className="DownloadXML"
          onClick={(e) =>
            this.handleViewXML(
              this.obs.item.chave,
              this.props.entrada_saida,
              this.props.modelo,
              this.obs.dhemi
            )
          }
        />

        <Button
          text="Download PDF"
          className="DownloadXML"
          style={{ marginRight: 10 }}
          onClick={(e) => this.handleViewPDF()}
        />

      </div>
    );
  }

  renderMemoriaCalc(memoria_calculo: string) {
    let calcName = this.obs.item.calc ? this.obs.item.calc : "Nenhum";

    return (
      <ItemMemoria
        memoria_calculo={memoria_calculo}
        calcName={calcName}
        calc_vars={ResultadoStore.obs.calc_vars}
        nota_vars={ResultadoStore.obs.nota_vars}
        descritivo={ResultadoStore.obs.descritivo_calc}
      />
    );
  }

  renderAlert() {
    return (
      <>
        <div style={{ marginBottom: 10 }}>
          <b>Alerta:</b> {this.obs.item.ie}
        </div>
      </>
    );
  }

  renderData() {
    return (
      <Tabs id="tabs" className="tabsCalculos">
        <Tab id="details" title="Detalhes" panel={this.renderDetailsTab()} />
        {this.obs.item.memoria_calculo ?
          <Tab
            id="calc"
            title="Memória de cálculo"
            panel={this.renderMemoriaCalc(this.obs.item.memoria_calculo)}
          />
          : <></>}
        {this.obs.item.memoria_calculo_1139 ?
          <Tab
            id="calc_1139"
            title="Memória de cálculo 1139"
            panel={this.renderMemoriaCalc(this.obs.item.memoria_calculo_1139)}
          />
          : <></>}
        {this.obs.item.ie && (
          <Tab id="alert" title="Alerta de Cálculo" panel={this.renderAlert()}>
            <span className="badge-emp pulse badge-tab"></span>
          </Tab>
        )}
      </Tabs>
    );
  }

  render() {
    let title = "Detalhes";
    if (this.obs.item) {
      title = `Detalhes: item ${this.obs.item.numero}`;
    }

    return (
      <Dialog
        isOpen={true}
        title={title}
        onClose={this.props.onClose}
        style={{ width: 650, height: 600 }}
      >
        <div className={Classes.DIALOG_BODY}>
          {(this.obs.item && this.renderData()) || this.renderNoData()}
        </div>
        <div className={Classes.DIALOG_FOOTER}>
          <div className={Classes.DIALOG_FOOTER_ACTIONS}>
            <Button text="Fechar" onClick={this.props.onClose} />
          </div>
        </div>
      </Dialog>
    );
  }
}
